import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { AngularFireDatabase} from 'angularfire2/database';
import { FormGroup, FormControl } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-spot',
  templateUrl: './new-spot.component.html',
  styleUrls: ['./new-spot.component.css']
})
export class NewSpotComponent implements OnInit {

  user: Observable<firebase.User>;
  errorMessageString = '';

  constructor(public afAuth: AngularFireAuth, public fb: FormBuilder, public router: Router, public db: AngularFireDatabase) {
    this.user = afAuth.authState;
  }

  public newSpotForm = new FormGroup({
    name: new FormControl("name", Validators.required),
    seats: new FormControl("seats", Validators.required),
    description: new FormControl("description", Validators.required),
    mondayFridayOpen: new FormControl("mondayFridayOpen", Validators.required),
    mondayFridayO: new FormControl("mondayFridayO", Validators.required),
    mondayFridayC: new FormControl("mondayFridayC", Validators.required),
    saturdayOpen: new FormControl("saturdayOpen", Validators.required),
    saturdayO: new FormControl("saturdayO", Validators.required),
    saturdayC: new FormControl("saturdayC", Validators.required),
    sundayOpen: new FormControl("sundayOpen", Validators.required),
    sundayO: new FormControl("sundayO", Validators.required),
    sundayC: new FormControl("sundayC", Validators.required),
    link: new FormControl("link", Validators.required),
    longitude: new FormControl("longitude", Validators.required),
    latitude: new FormControl("latitude", Validators.required)
  });

  ngOnInit() {

    var router = this.router;
    this.afAuth.auth.onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        console.log('user signed in');
        //router.navigate(['/home']);
      } else {
        // No user is signed in.
        console.log('user signed out');
      }
    });

    var ref = this.db.database.ref("/hello");
    ref.orderByChild('name').once('value', function(data){
      console.log('Data' + data.val().name);
    });

    ref.orderByChild('name').on("value", function(snapshot) {
      console.log('Data child' + snapshot.val().name);
    });

    this.newSpotForm.controls.name.setValue('');
    this.newSpotForm.controls.seats.setValue('');
    this.newSpotForm.controls.description.setValue('');
    this.newSpotForm.controls.mondayFridayOpen.setValue(false);
    this.newSpotForm.controls.mondayFridayO.setValue('');
    this.newSpotForm.controls.mondayFridayC.setValue('');
    this.newSpotForm.controls.saturdayOpen.setValue(false);
    this.newSpotForm.controls.saturdayO.setValue('');
    this.newSpotForm.controls.saturdayC.setValue('');
    this.newSpotForm.controls.sundayOpen.setValue(false);
    this.newSpotForm.controls.sundayO.setValue('');
    this.newSpotForm.controls.sundayC.setValue('');
    this.newSpotForm.controls.link.setValue('');
    this.newSpotForm.controls.longitude.setValue('');
    this.newSpotForm.controls.latitude.setValue('');

  }

  addSpot() {
    console.log("save nwe spot");

    var name = this.newSpotForm.controls.name.value;
    var seats = this.newSpotForm.controls.seats.value;
    var description = this.newSpotForm.controls.description.value;
    var mondayFridayOpen = this.newSpotForm.controls.mondayFridayOpen.value;
    var mondayFridayO = this.newSpotForm.controls.mondayFridayO.value;
    var mondayFridayC = this.newSpotForm.controls.mondayFridayC.value;
    var saturdayOpen = this.newSpotForm.controls.saturdayOpen.value;
    var saturdayO = this.newSpotForm.controls.saturdayO.value;
    var saturdayC = this.newSpotForm.controls.saturdayC.value;
    var sundayOpen = this.newSpotForm.controls.sundayOpen.value;
    var sundayO = this.newSpotForm.controls.sundayO.value;
    var sundayC = this.newSpotForm.controls.sundayC.value;
    var link = this.newSpotForm.controls.link.value;
    var longitude = this.newSpotForm.controls.longitude.value;
    var latitude = this.newSpotForm.controls.latitude.value;

    if(mondayFridayOpen == true) {
      var moFrO_date = '2017-01-01T' + mondayFridayO + ':00Z';
      var moFrC_date = '2017-01-01T' + mondayFridayC + ':00Z';
    } else {
      mondayFridayOpen = false;
      var moFrO_date = '';
      var moFrC_date = '';
    }

    if(saturdayOpen == true) {
      var saO_date = '2017-01-01T' + saturdayO + ':00Z';
      var saC_date = '2017-01-01T' + saturdayC + ':00Z';
    } else {
      saturdayOpen = false;
      var saO_date = '';
      var saC_date = '';
    }

    if(sundayOpen == true) {
      var soO_date = '2017-01-01T' + sundayO + ':00Z';
      var soC_date = '2017-01-01T' + sundayC + ':00Z';
    } else {
      sundayOpen = false;
      var soO_date = '';
      var soC_date = '';
    }
      
    this.db.database.ref('hello/').push({
      name: name,
      ampel_ID: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      sitzplaetze: seats,
      comment: description,
      MoFrOpen: mondayFridayOpen,
      MoFrO: {iso: moFrO_date},
      MoFrC: {iso: moFrC_date},
      SaOpen: mondayFridayOpen,
      SaO: {iso: saO_date},
      SaC: {iso: saC_date},
      SoOpen: sundayOpen,
      SoO: {iso: soO_date},
      SoC: {iso: soC_date},
      location: {latitude: latitude, longitude: longitude},
      messages: '',
      objectId: '',
      pictures: {},
      wifi: true,
      behindertengerecht: true, //to be changed
      klimatisiert: true,
      
    });
    
    
  }

}



// WEBPACK FOOTER //
// ./src/app/new-spot/new-spot.component.ts